// StyledPickers.js
import { styled } from '@mui/material/styles';
import { StaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';

export const StyledStaticTimePicker = styled(StaticTimePicker)(({ theme }) => ({
  backgroundColor: "transparent",
  color: "white",
  "& .MuiClockNumber-root": {
    color: "white",
  },
  "& .MuiClockNumber-root.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.3)",
  },
  "& .MuiTypography-root": {
    color: "white",
  },
  "& .MuiPickersArrowSwitcher-button": {
    color: "white",
  },
  "& .MuiPickersArrowSwitcher-button.Mui-disabled": {
    color: "rgba(255, 255, 255, 0.3)",
  },
  "& .MuiPickersToolbarText-root": {
    color: "white",
  },
  "& .MuiPickersToolbarText-root.Mui-selected": {
    color: "white",
  },
  "& .MuiPickersToolbarText-root:not(.Mui-selected)": {
    color: "rgba(255, 255, 255, 0.3)",
  },
  "& .MuiTimePickerToolbar-root": {
    marginTop: "0px",
    marginBottom: "0px",
    padding: "0",
    minHeight: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  "& .MuiClockPicker-root": {
    marginTop: "0",
    paddingTop: "0",
  },
  "& .MuiPickerToolbar-root": {
    padding: "0px 0",
    minHeight: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  "& .MuiTimePickerToolbar-hourMinuteLabel .MuiPickersToolbarText-root": {
    fontSize: "2.0rem",
    fontFamily: "'Roboto', sans-serif",
  },
  "& .MuiTimePickerToolbar-separator": {
    fontSize: "1.8rem",
  },
  "& .MuiTimePickerToolbar-ampmSelection .MuiButtonBase-root .MuiPickersToolbarText-root": {
    fontSize: "0.8rem",
  },
  "& .MuiTimePickerToolbar-ampmSelection": {
    display: "none",
  },
}));
